var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container"},[_c('img',{attrs:{"src":this.$PATH.GET_IMAGE_PATH('loading.gif'),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }